import { ButtonLink } from "@vixi/ui";
import { useTranslation } from "@vixi/localization";
import { FC } from "react";

export const CourseDraftSaved: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="m-auto max-w-128.75 text-center text-[21px]">
        <p className="text-success text-[21px]">{t("SuccessMessage.Congrats")}</p>
        <p className="text-text-secondary mt-5.25">{t("SuccessMessage.CourseSavedToDrafts")}</p>
        <p className="text-text-secondary mt-5.25">{t("Courses.CanViewCourseMessage")}</p>
      </div>

      <div className="fixed end-33.75 bottom-25">
        <ButtonLink to="/courses" variant="contained" size="large">
          {t("Action.GoToMyCourses")}
        </ButtonLink>
      </div>
    </>
  );
};
